// src/pages/ThankYou.js
import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import './ThankYou.css';

function ThankYou() {
  return (
    <div>
      <Navbar />
      <div className="thankyou-container">
        <h1>Thank You!</h1>
        <p>Thank you for getting in touch with us. We will respond to your message as soon as possible.</p>
        <Link to="/" className="home-button">Go Home</Link>
      </div>
    </div>
  );
}

export default ThankYou;
